import { LocalStorageKeys } from 'helpers/localStorage';
import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import type { ICookieProps } from './components/Cookie';
import { Cookie } from './components/Cookie';

type AdditionalModalProps = Pick<ICookieProps, 'bottom'>;

export const AdditionalModal: FC<AdditionalModalProps> = (props) => {
  const [isOpenCookieModal, setIsOpenCookieModal] = useState(false);

  useEffect(() => {
    setIsOpenCookieModal(localStorage.getItem(LocalStorageKeys.Cookie) == null);
  }, []);

  const handleAcceptCookie = useCallback(() => {
    localStorage.setItem(LocalStorageKeys.Cookie, 'true');
    setIsOpenCookieModal(false);
  }, [setIsOpenCookieModal]);

  return (
    <>
      {isOpenCookieModal && <Cookie onClose={handleAcceptCookie} {...props} />}
    </>
  );
};
